import React, { useEffect, useState } from 'react';
import SoftInput from 'components/SoftInput';
import SoftBox from 'components/SoftBox';
import ApnaSelect from 'components/ApnaSelect';
import SoftButton from 'components/SoftButton';
import SoftTypography from 'components/SoftTypography';
import { useDispatch, useSelector } from 'react-redux';
import { getCategoryData } from 'api/commonSlice';
import { getSubCategoryData } from 'api/commonSlice';
import MultiTag from 'components/MultiTag/index';
import MultiTagBusiness from 'components/MultiTag/business';
import { baseURL } from 'utils/api';
import toast from 'react-hot-toast';
import ReactQuill from 'react-quill';
import SelectLocation from "components/location";
import LocationSearch from "layouts/authentication/sign-up/googleInput";
import { getKeywordsData } from 'api/commonSlice';
import ApplyModal from './ApplyModal';
import './style.css'
import {
  Card,
  CircularProgress,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";


const GeneralInformation = ({ data, profile, handelRefresh }) => {


  const matches = useMediaQuery("(max-width:600px)");
  const dispatch = useDispatch();
  const [addressData, setAddressData] = useState('')
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [description, setDescription] = useState('');
  const keywords = useSelector((state) => state.commonSlice?.keywords);
  const [keywordIds, setKeywordIds] = useState([]);
  const [searchFirst, setSearchFirst] = useState(false);
  const [madeChanges, setMadeChanges] = useState(false);
  const [show, setShow] = useState(false);
  const [selectBranches, setSelectBranches] = useState([]);
  const [numberValidation, setNumberValidation] = useState(false);
  const [branches, setBranches] = useState([])
  const categoryData = useSelector((state) => state.commonSlice?.category);
  const subCategoryData = useSelector((state) => state.commonSlice?.subCategory)
  const id = localStorage.getItem("id");
  const [loading, setLoading] = useState(false);
  const userTheme = useSelector((state) => state.commonSlice.theme);


  useEffect(() => {
    const fetchData = async () => {
      try {
        fetch(`${baseURL}allLocations/${id}`)
          .then((res) => res.json())
          .then((res) => {
            if (res.success) {
              setBranches(res?.data);
            }
          });
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  const handleBranchChange = (event, value) => {
    setSelectBranches(value);
    setMadeChanges(true);
  };




  const [values, setValues] = useState({
    businessEmail: "",
    businessName: "",
    businessPhone: "",
    category: "",
    subCategory: "",
    keywords: [],
    mainAddress: "",
    address: "",
    country: "",
    city: "",
    state: "",
    zipCode: "",
    county: "",
    fbLink: "",
    instagramLink: "",
    twitterLink: "",
    website: "",
    latitude: 0,
    longitude: 0,
    locationName: "",
  });
  useEffect(() => {
    if (data?.category?._id) {
      dispatch(getKeywordsData(data?.category?._id));
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      // Set initial values
      setValues({
        businessEmail: data?.businessEmail || '',
        businessName: data?.businessName || '',
        businessPhone: data?.businessPhone || '',
        category: data?.category?._id || '',
        keywords: [], // Initialize as empty; will be updated below
        subCategory: data?.subCategory?._id || '',
        mainAddress: data?.address?.addLine || '',
        address: data?.address?.addLine || '',
        country: data?.address?.country?.name || '',
        city: data?.address?.city?.name || '',
        state: data?.address?.state?.name || '',
        zipCode: data?.address?.zipcode || '',
        county: data?.address?.subAddLine || '',
        fbLink: data?.links?.fbLink || '',
        instagramLink: data?.links?.instagramLink || '',
        twitterLink: data?.links?.twitterLink || '',
        website: data?.links?.website || '',
        longitude: data?.location?.coordinates?.[0] || -82.46371629474554,
        latitude: data?.location?.coordinates?.[1] || 27.953573206285228,
        locationName: data?.locationName || '',
      });

      // Process keywords only if both 'data.keywords' and 'keywords' are available
      if (data?.keywords && keywords?.length > 0) {
        const newKeywords = [];
        keywords.forEach((item) => {
          const findKeyword = data?.keywords?.find(
            (keyword) => keyword?._id === item?._id
          );
          if (findKeyword) {
            newKeywords.push(findKeyword);
          }
        });
        setValues((prevValues) => ({
          ...prevValues,
          keywords: newKeywords,
        }));
      } else {
        // If no data.keywords, ensure keywords are cleared
        setValues((prevValues) => ({
          ...prevValues,
          keywords: [],
        }));
      }

      // Update other states
      setSelectBranches([data]);
      setDescription(data?.description || '');

      // Fetch subcategories if category exists
      if (data?.category?._id) {
        dispatch(getSubCategoryData(data?.category?._id));
      }
    } else {
      // Reset all values when no data is available
      setValues({
        businessEmail: '',
        businessName: '',
        businessPhone: '',
        category: '',
        subCategory: '',
        keywords: [],
        mainAddress: '',
        address: '',
        country: '',
        city: '',
        state: '',
        zipCode: '',
        county: '',
        fbLink: '',
        instagramLink: '',
        twitterLink: '',
        website: '',
        latitude: 0,
        longitude: 0,
        locationName: '',
      });
    }
  }, [data, keywords]); // Include 'keywords' in the dependency array



  useEffect(() => {
    if (addressData) {
      setValues((prev) => ({
        ...prev,
        mainAddress: addressData?.address,
        address: addressData?.address,
        city: addressData?.city,
        state: addressData?.state,
        country: addressData?.country,
        zipCode: addressData?.zipcode,
        county: addressData?.subAddress || '',
      }));
    }
  }, [addressData]);


  useEffect(() => {
    dispatch(
      getCategoryData(),
    );
  }, []);

  useEffect(() => {
    categoryData && categoryData?.length > 0 &&
      setCategories(categoryData?.map((item) => ({ name: item?.name, _id: item?._id })))
  }, [categoryData]);

  useEffect(() => {
    subCategoryData && subCategoryData?.length > 0 &&
      setSubCategories(subCategoryData?.map((item) => ({ name: item?.name, _id: item?._id })))
  }, [subCategoryData])


  const handleCategoryChange = (e) => {
    setValues({ ...values, category: e.target.value });
    dispatch(getSubCategoryData(e.target.value));
    // dispatch(getKeywordsData(e.target.value));
  };

  const onChangeSubCategory = (e) => {
    setValues({ ...values, subCategory: e.target.value });
    setMadeChanges(true);
  };

  const updateProfile = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (values?.businessPhone?.length > 12 || values?.businessPhone?.length < 8) {
      setLoading(false);
      toast.error('Phone number must be between 8 to 12 digits');
      return;
    }
    if (values.keywords.length === 0) {
      setLoading(false);
      toast.error('Please select keywords')
      return;
    }


    // const findCityId = await fetch(`${baseURL}getAddressByCityName/${values.city}`).then(res => res.json());

    // if (findCityId.success) {
    //   values.city = findCityId.data?._id;
    //   values.state = findCityId.data?.state?._id;
    //   values.country = findCityId.data?.country?._id;
    // }

    const formData = new FormData();
    formData.append('businessEmail', values.businessEmail)
    formData.append('businessPhone', values.businessPhone)
    formData.append('businessName', values.businessName)
    formData.append('category', values.category)
    formData.append('subCategory', values.subCategory)
    formData.append('description', description)
    formData.append('addLine', values.mainAddress)
    formData.append('subAddLine', values.county || '')
    formData.append('country', values.country)
    formData.append('city', values.city)
    formData.append('state', values.state)
    formData.append('zipcode', values.zipCode)
    formData.append('latitude', values.latitude)
    formData.append('longitude', values.longitude)
    formData.append('locationName', values.locationName)
    formData.append('fbLink', values.fbLink)
    formData.append('instagramLink', values.instagramLink)
    formData.append('website', values.website);

    values.keywords && values.keywords.length > 0 && values.keywords.map((item, i) => {
      formData.append(`keywords`, item?._id,)
    });

    selectBranches && selectBranches.length > 0
    selectBranches.map((elm) => {
      formData.append(`branches`, elm._id)
    })

    fetch(`${baseURL}updateBusiness/${data?._id}`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: formData
    }).then(res => res.json())
      .then(data => {
        setLoading(false);
        if (data.success) {
          handelRefresh();
          toast.success('Profile Updated Successfully')
        } else {
          toast.error(data.message)
        }
      }
      ).catch(err => {
        setLoading(false);
        toast.error(err.message || 'Something went wrong');
      });
  };

  const handleChangeKeywords = (e, value) => {
    setValues({ ...values, keywords: value });
    setKeywordIds(value?.map(item => item?._id));
    setMadeChanges(true);
  }

  const onChange = (e) => {
    // if (e.target.name === 'businessPhone' && e?.target?.value?.length > 12 || e?.target?.value?.length < 8) {
    //   setNumberValidation(true)
    // } else {
    //   setNumberValidation(false)
    // }
    setValues({ ...values, [e.target.name]: e.target.value });
    setMadeChanges(true);
  }




  return (
    <SoftBox>
      <ApplyModal description={description} show={show} unShow={setShow} values={values} />
      <form onSubmit={updateProfile}>
        <SoftBox noValidate autoComplete="off">
          <SoftBox gap={matches ? 0 : 2} display="flex" flexDirection={matches ? 'column' : 'row'}>
            <SoftBox
              width={matches ? "100%" : "33%"}
            >
              <SoftTypography
                variant="caption"
              >
                Business Name
              </SoftTypography>

              <SoftInput
                disabled
                value={values.businessName}
                onChange={onChange}
                name="businessName"
                label="Business Name" placeholder="Enter Business Name" />
            </SoftBox>
            <SoftBox

              width={matches ? "100%" : "33%"}
            >
              <SoftTypography
                variant="caption"
              >
                Business Email
              </SoftTypography>

              <SoftInput
                disabled
                value={values.businessEmail}
                onChange={onChange}
                name="businessEmail"
                label="Email" placeholder="Email@example.com" />

            </SoftBox>
            <SoftBox
              width={matches ? "100%" : "33%"}
            >
              <SoftTypography
                variant="caption">
                Phone Number *
              </SoftTypography>
              <SoftInput
                required
                value={values.businessPhone}
                onChange={onChange}
                name="businessPhone"
                label="Phone Number *"
                placeholder="(+02) 000-0000"
                type="tel"
                maxLength={12}
              />
              {numberValidation && <SoftTypography variant="caption" color="error" sx={{ color: 'red', mt: 0, ml: 1 }}>
                Enter valid phone number
              </SoftTypography>}
            </SoftBox>
          </SoftBox>


          <SoftBox
            gap={2}
            display="flex"
          >
            {/* Category Section */}

            <SoftBox width="50%">
              <SoftTypography
                variant="caption"
              >
                Category *
              </SoftTypography>
              <ApnaSelect
                required
                value={values.category}
                label="Category *"
                options={categories}
                onChange={handleCategoryChange}
                className="custom-select-style "
                selectClass="select-transparent"
              />
            </SoftBox>

            {/* Sub-category Section */}
            <SoftBox
              width="50%"
            >
              <SoftTypography
                variant="caption"
              >
                Sub-category *
              </SoftTypography>
              <ApnaSelect
                required
                label="Sub-category *"
                value={values.subCategory}
                options={subCategories}
                onChange={onChangeSubCategory}
                className="custom-select-style"
                selectClass="select-transparent"
              />
            </SoftBox>
          </SoftBox>

          <SoftTypography
            sx={{ marginBottom: 1, marginTop: 2 }}
            variant="h6"
            fontWeight="bold"
          >
            Address Details
          </SoftTypography>

          <SoftBox>
            <LocationSearch setSearchFirst={setSearchFirst} setMadeChanges={setMadeChanges} setValues={setValues} setAddressData={setAddressData} fetchApi={true} />
          </SoftBox>

          <SoftBox>
            <SoftTypography
              variant="caption"
            >
              Address
            </SoftTypography>
            <SoftInput
              disabled
              value={values.mainAddress}
              onChange={onChange}
              name="mainAddress"
              label="Main Address"
              placeholder="enter address"
            />
          </SoftBox>

          <SoftBox
            display="flex"
            flexDirection={matches ? 'column' : 'row'}
            justifyContent="space-between"
            gap={matches ? 0 : 2}
          >
            <SoftBox sx={{ width: "100%" }}>
              <SoftTypography
                variant="caption"
              >
                City *
              </SoftTypography>
              <SoftInput
                required
                disabled
                value={values.city}
                onChange={onChange}
                name="city"
                placeholder="Tampa"
                type="text"
              />
            </SoftBox>

            <SoftBox sx={{ width: "100%" }}>
              <SoftTypography
                variant="caption"
              >
                State *
              </SoftTypography>
              <SoftInput
                disabled
                required
                value={values.state}
                onChange={onChange}
                name="state"
                placeholder="FL"
                type="text"
              />
            </SoftBox>

            <SoftBox sx={{ width: "100%" }}>
              <SoftTypography
                variant="caption"
              >
                Country *
              </SoftTypography>
              <SoftInput
                required
                disabled
                value={values.country}
                onChange={onChange}
                name="country"
                placeholder="USA"
                type="text"
              />
            </SoftBox>
          </SoftBox>

          <SoftBox gap={matches ? 0 : 2} display="flex" flexDirection={matches ? 'column' : 'row'}>

            <SoftBox sx={{ width: "100%" }}>
              <SoftTypography
                variant="caption"
              >
                Zip Code *
              </SoftTypography>
              <SoftInput
                required
                disabled
                value={values.zipCode}
                onChange={onChange}
                name="zipCode"
                placeholder="33602"
                type="number"
                min={6}
              />
            </SoftBox>

            <SoftBox sx={{ width: "100%" }}>
              <SoftTypography
                variant="caption"
              >
                Latitude
              </SoftTypography>
              <SoftInput
                value={values.latitude}
                disabled
                name="latitude"
                placeholder="27.9506"
                type="text"
              />
            </SoftBox>


            <SoftBox sx={{ width: "100%" }}>
              <SoftTypography
                variant="caption"
              >
                Longitude
              </SoftTypography>
              <SoftInput
                value={values.longitude}
                disabled
                name="longitude"
                placeholder="-82.4572"
                type="text"
              />
            </SoftBox>
          </SoftBox>

          <SoftBox mt={2}>
            <SelectLocation
              disabled={!searchFirst}
              lat={values.latitude}
              lng={values.longitude}
              setValues={setValues}
              setAddressData={setAddressData}
              fetchApi={true}
            />
          </SoftBox>

          <SoftBox>
            <SoftTypography
              variant="caption"
            >
              Location Name *
            </SoftTypography>
            <SoftInput
              required
              value={values.locationName}
              onChange={onChange}
              name="locationName"
              placeholder="Home"
              type="text"
            />
          </SoftBox>


          <Card className="glassmorphism-card"
            sx={{
              padding: 2,
              marginTop: 2
            }}
          >


            <SoftBox
              sx={{ zIndex: 999 }}
            >
              <SoftTypography
                variant="caption"
              >
                Description
              </SoftTypography>
              <div className={`quill-wrapper ${userTheme === 'dark' ? 'dark-theme' : ''}`}>
                <ReactQuill
                  value={description}
                  onChange={
                    (value) => {
                      setDescription(value);
                      setMadeChanges(true);
                    }
                  }
                  name="description"
                  label="Description"
                  placeholder="Enter a description"
                  style={{ height: '200px' }}
                />
              </div>
            </SoftBox>

            {/* Keywords */}
            <SoftBox sx={{ mt: 8 }}>
              <SoftTypography
                variant="caption"
              >
                Keywords *
              </SoftTypography>
              {
                keywords && keywords.length > 0 &&
                <MultiTag
                  required
                  value={values?.keywords || []}
                  label="Keywords *"
                  placeholder="Enter Keywords"
                  onChange={handleChangeKeywords}
                  data={keywords}

                />
              }

            </SoftBox>

            {/* Social Media */}
            <SoftTypography
              variant="h6"
              fontWeight="bold"
              marginTop={3}
              marginBottom={2}
            >
              Social Media Links
            </SoftTypography>
            <SoftBox> <SoftTypography variant="caption">Facebook URL </SoftTypography>
              <SoftInput sx={{ marginBottom: 2 }}
                name="fbLink"
                value={values.fbLink}
                onChange={onChange}
                label="Facebook URL" placeholder="Enter Facebook URL" />
            </SoftBox>
            <SoftBox> <SoftTypography variant="caption">Instagram URL </SoftTypography>
              <SoftInput sx={{ marginBottom: 2 }}
                name="instagramLink"
                value={values.instagramLink}
                onChange={onChange}
                label="Instagram URL" placeholder="Enter Instagram URL" />
            </SoftBox>

            <SoftBox> <SoftTypography variant="caption">Website </SoftTypography>
              <SoftInput sx={{ marginBottom: 2 }}
                name="website"
                value={values.website}
                onChange={onChange}
                label="Twitter URL" placeholder="Enter Twitter URL" />
            </SoftBox>
            <SoftBox> <SoftTypography variant="caption"> Apply the settings to the following locations </SoftTypography>

              {
                branches && branches.length > 0 &&
                <MultiTagBusiness
                  required
                  value={selectBranches || []}
                  label="branches *"
                  placeholder="Select branches"
                  onChange={handleBranchChange}
                  data={branches}
                />
              }
            </SoftBox>

          </Card>

          {/* Buttons */}
          <SoftBox sx={{ mt: 4 }}
            display="flex"
            justifyContent="space-between"
            gap={2}
          >
            <SoftButton variant="outlined" color="info"
              onClick={() => window.location.reload()}
              fullWidth
            >
              Cancel
            </SoftButton>
            <SoftButton
              fullWidth
              variant="gradient"
              color={madeChanges ? "info" : 'light'}
              disabled={!madeChanges}
              sx={{ marginRight: 2 }}
              type="submit"
            >
              {
                loading ? <CircularProgress size={24} color='white' /> : 'Save Changes'
              }
            </SoftButton>

          </SoftBox>
        </SoftBox>
      </form>
    </SoftBox>
  );
};



export default GeneralInformation;








